module.exports = __webpack_public_path__ + "img/workContents05-00_flow-chart.561ac694.png";